<template>
  <div :class="['brand', position]">
    <img
      v-if="type === `light`"
      class="brand__image"
      src="@/assets/practices/global/brand/hmp_logo_white.svg"
      alt="brand_image"
    />
    <img
      v-if="type === `dark`"
      class="brand__image"
      src="@/assets/practices/global/brand/hmp_logo_black.svg"
      alt="brand_image"
    />
  </div>
</template>

<script>
export default {
  name: 'Brand',
  props: {
    // eslint-disable-next-line vue/require-default-prop
    type: String,
    // eslint-disable-next-line vue/require-default-prop
    position: String,
  },
};
</script>

<style lang="scss" scoped>
.brand {
  align-items: center;
  display: flex;
  justify-content: center;
  position: absolute;
  z-index: 100;

  &__image {
    height: 8vh;
  }
}

.bottom {
  bottom: 2.5vh;
}

.bottom-left {
  bottom: 2.5vh;
  left: 2.5vh;
}

.bottom-right {
  bottom: 2.5vh;
  right: 2.5vh;
}

.top {
  top: 2.5vh;
}

.top-left {
  left: 2.5vh;
  top: 2.5vh;
}

.top-right {
  right: 2.5vh;
  top: 2.5vh;
}
</style>
